export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10909.f1400e11.jpg";